const BI_PREVIEW_TOKENS = ['kshitij', 'kshitijshivprasad'];

export const canUseBusinessIntelligence = (user = {}) => {
  const identity = `${user.email || ''} ${user.name || ''} ${user.employee_code || ''}`.toLowerCase();
  return BI_PREVIEW_TOKENS.some((token) => identity.includes(token));
};
